import React from 'react';
import { useParams } from 'react-router-dom';
import MieterListeSeite from './liste/MieterListeSeite';
import MieterSeite from './detail/MieterSeite';

interface MieterListeProps {
  initialMieterId?: string | null;
  onClearInitial?: () => void;
  onNavigateToObjekt?: (id: string) => void;
}

/** Bereich „Mieter“ im neuen Design (Handoff Mieter): Liste und Detail (/admin/mieter/:mieterId). */
const MieterListe: React.FC<MieterListeProps> = ({ initialMieterId, onClearInitial, onNavigateToObjekt }) => {
  const { mieterId } = useParams<{ mieterId: string }>();
  // key: beim Wechsel des Mieters neu aufbauen – offenes Panel schließt, Gruppe steht wieder auf „Alle“
  if (mieterId) return <MieterSeite key={mieterId} mieterId={mieterId} onNavigateToObjekt={onNavigateToObjekt} />;
  return <MieterListeSeite initialMieterId={initialMieterId} onClearInitial={onClearInitial} />;
};

export default MieterListe;
